import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-lazy-load-image-component/src/effects/blur.css';
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import App from './App';
import './index.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);